"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrevNextRel = void 0;
var PrevNextRel;
(function (PrevNextRel) {
    PrevNextRel["PREV"] = "prev";
    PrevNextRel["NEXT"] = "next";
})(PrevNextRel || (exports.PrevNextRel = PrevNextRel = {}));
//# sourceMappingURL=seo.js.map